<template>
  <div class="coach-box coachbox">
    <img
      class="coachbox_avatar"
      :src="getImage(item.img)"
    />
    <div class="coachbox_name">
      {{ item.nick }}
    </div>
    <div
      class="coachbox_tag"
      :style="`--clr-tag:var(--clr-${item.format})`"
      :class="item.format"
    >
      {{ item.format === 'theory' ? $t(`common.theory`) : $t(`gametypes.groups.${item.format}`) }}
    </div>
    <div class="coachbox_fullname">{{ item.fullname }}</div>
    <div class="coachbox_text">
      {{ item.bio }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoachBox',
  props: {
    item: Object,
  },
  data() {
    return {}
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/coaches/${img}`, import.meta.url).href
    },
  },
}
</script>

<style lang="scss" scoped>
.coachbox {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 8px;
  padding: 2rem 1.5rem 2rem 1.5rem;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: center;

  --img-size: 10rem;
  --clr-back: var(--clr-black-1);
  --clr-back-hover: var(--clr-black-1-2);
  background: var(--clr-back);
  color: var(--clr-white-0);

  transition: 0.22s;
  &_avatar {
    border-radius: 50%;
    width: var(--img-size);
    height: var(--img-size);
    flex-shrink: 0;
    transition: inherit;
    border: solid 4px var(--clr-black);
    object-fit: cover;
  }
  &_name {
    font-weight: 500;
    margin-top: 1.25rem;
    font-size: 1.25rem;
  }
  &_fullname {
    font-weight: 500;
    color: var(--clr-grey-2);
    font-size: 1rem;
  }
  &_text {
    margin-top: 0.75rem;
    font-size: 0.8rem;
    color: var(--clr-grey-2);
  }
  &_tag {
    position: relative;
    position: absolute;
    top: 1rem;
    left: 1rem;
    border-radius: 4px;
    background: var(--clr-black-2);
    font-size: 0.8rem;
    color: var(--clr-white-0);
    padding: 0 0.25rem;
    margin: 0.25rem 0.25rem 0.25rem 0;
    text-transform: uppercase;
    overflow: hidden;
    padding: 0 0.25rem 0 0.75rem;
    --clr-tag: red;
    flex-shrink: 0;
    &:before {
      content: '';
      height: 100%;
      width: 6px;
      position: absolute;
      background: var(--clr-tag);
      left: 0;
      top: 0;
    }
  }
}
</style>
